import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { PrimeIcons } from "primereact/api";
import { Image } from "primereact/image";
import { Divider } from "primereact/divider";
import { Tree } from "primereact/tree";
import { useEffect, useRef, useState } from "react";
import { TreeNode } from "primereact/treenode";
import { Tooltip } from "primereact/tooltip";

import { useAppDispatch, useAppSelector } from "store/store";
import { getFileIconByFileType } from "utils";
import {
  labelCodes,
  labelArchivio,
  labelPrivate,
  labelTooltipPdf,
  labelUpdate,
  labelDelete,
  modalConfirmDeleteDataSourceSubtitlePart1,
  modalConfirmDeleteDataSourceSubtitlePart2,
  snackbarDataDeleted,
  snackbarSummarySourceAddSuccessSubTitlePart1,
  snackbarSummarySourceDeleteSuccessSubTitlePart2,
  modalConfirmDeleteSource,
  labelArchive,
  labelCodex,
  labelPrivates,
  snackbarSeverityInfo,
  snackbarSourceNotReady,
  snackbarResetChat,
  snackbarSummaryResetChatSubTitle,
} from "_constants";
import {
  ModalDetailSourceProject,
  ModalPrivateSource,
} from "components/modals";
import {
  checkLastResetChat,
  checkSource,
  deleteSourceFromProject,
  getDetailSource,
  getStateSource,
} from "services";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  resetLoadedStatus,
  updateSourceProject,
} from "store/slicer/GestioneDetailProjectSlice";
import { CheckSourceRequest, ProjectSource } from "interfaces";
import { setSource } from "store/slicer/GestioneSourceSlice";
import { setCheckInactiveAnswers } from "store/slicer/GestioneChatSlice";

export const CheckboxSourcesList = ({ projectId }: { projectId: string }) => {
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [canRemoveActiveClass, setCanRemoveActiveClass] = useState(true);
  const [menuItems, setMenuItems] = useState<any>();
  const { showSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const [selectedKeys, setSelectedKeys] = useState<any>(null);
  const [selectedNode, setSelectedNode] = useState<any>(null);
  const [showModalPrivateSource, setShowModalPrivateSource] = useState(false);
  const [showModalDetailSource, setShowModalDetailSource] = useState(false);
  const { showConfirmDialogDelete } = useConfirmDialogExit();

  const detailSource = useAppSelector((state) => state.gestioneSourceSlice);

  const listSourceProject = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.listSourceProject
  );
  const projectList = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.listSourceProjectFiltered
  );
  const menu = useRef<Menu>(null);
  let selectedNodeFormActions: any;

  const itemsPrivate = [
    {
      label: labelUpdate,
      icon: PrimeIcons.PENCIL,
      command: () => {
        if (selectedNodeFormActions || selectedNode) {
          getStateSource((selectedNodeFormActions || selectedNode).key)
            .then((res) => {
              if (res.data.elaborated) {
                getDetailSource(
                  (selectedNodeFormActions || selectedNode).key,
                  projectId
                )
                  .then((res) => {
                    dispatch(setSource(res.data));
                    setShowModalPrivateSource(true);
                  })
                  .catch((_) => { });
              } else {
                showSnackbar({
                  severity: snackbarSeverityInfo,
                  summary: snackbarSeverityInfo,
                  detail: snackbarSourceNotReady,
                  life: 5000,
                });
              }
            })
            .catch((_) => { });
        }
      },
    },
    {
      separator: true,
    },
    {
      label: labelDelete,
      icon: PrimeIcons.TRASH,
      className: "delete-color",
      command: () => {
        getStateSource((selectedNodeFormActions || selectedNode).key)
          .then((res) => {
            if (res.data.elaborated) {
              showConfirmDialogDelete({
                title: modalConfirmDeleteSource,
                subtitle: `${modalConfirmDeleteDataSourceSubtitlePart1}<span class="font-weight-700">${(selectedNodeFormActions || selectedNode).label
                  }</span>${modalConfirmDeleteDataSourceSubtitlePart2}`,
                rejectCallback: callDeleteSource,
              });
            } else {
              showSnackbar({
                severity: snackbarSeverityInfo,
                summary: snackbarSeverityInfo,
                detail: snackbarSourceNotReady,
                life: 5000,
              });
            }
          })
          .catch((_) => { });
      },
    },
  ];

  const items = [
    {
      label: labelDelete,
      icon: PrimeIcons.TRASH,
      className: "delete-color",
      command: () => {
        showConfirmDialogDelete({
          title: modalConfirmDeleteSource,
          subtitle: `${modalConfirmDeleteDataSourceSubtitlePart1}<span class="font-weight-700">${selectedNodeFormActions?.label}</span>${modalConfirmDeleteDataSourceSubtitlePart2}`,
          rejectCallback: callDeleteSource,
        });
      },
    },
  ];

  useEffect(() => {
    const data = [
      {
        key: "CODEX",
        label: labelCodes,
        children: projectList.codesList
          .map((code) => ({
            key: code?.id,
            label: code.name,
            type: labelCodex,
            isChecked: code?.isChecked,
          }))
          .sort((a, b) => Number(b.isChecked) - Number(a.isChecked)),
      },
      {
        key: "ARCHIVE",
        label: labelArchivio,
        children: projectList.sourcesList
          .map((source) => ({
            key: source?.id,
            label: source.name,
            fileType: source.fileType,
            type: labelArchive,
            isChecked: source?.isChecked,
          }))
          .sort((a, b) => Number(b.isChecked) - Number(a.isChecked)),
      },
      {
        key: "PRIVATE",
        label: labelPrivate,
        children: projectList.privateSourcesList
          .map((privateSource) => ({
            key: privateSource?.id,
            label: privateSource.name,
            fileType: privateSource.fileType,
            type: labelPrivates,
            isChecked: privateSource?.isChecked,
          }))
          .sort((a, b) => Number(b.isChecked) - Number(a.isChecked)),
      },
    ];
    setMenuItems(items);
    setNodes(data);
    setCheckKeys(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    projectList.codesList,
    projectList.privateSourcesList,
    projectList.sourcesList,
  ]);

  const callDeleteSource = () => {
    deleteSourceFromProject(selectedNodeFormActions.key, projectId)
      .then((_) => {
        checkLastResetChat(projectId).then((res) => {
          if (res.data.canShowWarning) {
            dispatch(setCheckInactiveAnswers(true));
            showSnackbar({
              severity: "warn",
              summary: snackbarResetChat,
              detail: snackbarSummaryResetChatSubTitle,
              life: 5000,
            });
          }
        }).catch((_) => { });
        showSnackbar({
          severity: "success",
          summary: snackbarDataDeleted,
          detail: `${snackbarSummarySourceAddSuccessSubTitlePart1}${selectedNodeFormActions.label}${snackbarSummarySourceDeleteSuccessSubTitlePart2}`,
          life: 5000,
        });
        const selectList =
          selectedNodeFormActions.type === labelCodex
            ? "codesList"
            : selectedNodeFormActions.type === labelArchive
              ? "sourcesList"
              : "privateSourcesList";
        dispatch(
          updateSourceProject({
            listName: selectList,
            source: selectedNodeFormActions.key,
          })
        );

        setShowModalPrivateSource(false);
        setShowModalDetailSource(false);
      })
      .catch((_) => { });
  };

  const setCheckKeys = (data: TreeNode[]) => {
    let obj: any = {};
    data.forEach((el: any) => {
      if (el.children?.length) {
        const len = el.children.length;
        let checkedItem = 0;
        el.children.forEach((item: any) => {
          if (item.isChecked) {
            obj[item.key] = {
              checked: true,
              partialChecked: false,
            };
            checkedItem++;
          }
        });
        if (checkedItem > 0) {
          obj[el.key] = {
            checked: checkedItem === len,
            partialChecked: checkedItem < len,
          };
        } else {
          obj[el.key] = {
            checked: false,
            partialChecked: false,
          };
        }
      }
      setSelectedKeys(obj);
    });
  };

  const nodeTemplate = (node: any) => {
    const isParentNode = !!node.children;
    const isFileType = node.fileType;
    const roundSourceLabel = () => {
      if (node.label === "Codici") {
        return <span className="round-source margin-right-5"></span>;
      } else if (node.label === "Archivio") {
        return <span className="round-source margin-right-5 archive"></span>;
      } else if (node.label === "Privata") {
        return <span className="round-source margin-right-5 private"></span>;
      }
      return null;
    };

    const setElementActive = (key: string) => {
      if (canRemoveActiveClass) {
        removeActiveClass();
        document.getElementById(`node-${key}`)?.classList.add("active");
      }
    };

    const onShowMenu = () => {
      setCanRemoveActiveClass(false);
    };
    const onHideMenu = () => {
      setCanRemoveActiveClass(true);
      removeActiveClass();
    };

    const removeActiveClass = () => {
      if (canRemoveActiveClass) {
        document.querySelectorAll(".tree-source")?.forEach((el) => {
          el.classList.remove("active");
        });
      }
    };

    const getSourceDetail = (sourceId: string) => {
      getDetailSource(sourceId, projectId)
        .then((res) => {
          setSelectedNode(node);
          dispatch(setSource(res.data));
          setShowModalDetailSource(true);
        })
        .catch((_) => { });
    };

    return (
      <div
        className="flex-container align-center relative width-76 tree-source"
        onMouseOver={(e) => setElementActive(node.key)}
        onMouseLeave={removeActiveClass}
        id={`node-${node.key}`}
        onClick={(e) => {
          e.stopPropagation();
          if (!isParentNode) {
            getSourceDetail(node.key);
          }
        }}
      >
        {isParentNode && roundSourceLabel()}
        {!isParentNode && isFileType && (
          <Image
            className="flex-container"
            src={getFileIconByFileType(node.fileType)}
            alt={labelTooltipPdf}
          />
        )}
        <Tooltip
          target={`.checkbox-label`}
          position="bottom"
          mouseTrack
          mouseTrackLeft={10}
        />
        <span
          className={`margin-left-4 ellipsis width-75 checkbox-label text-title ${isParentNode ? "font-weight-700" : ""
            }`}
          data-pr-tooltip={!isParentNode ? node.label : ""}
        >
          {node.label}
        </span>
        <div className="absolute absolute-right-0">
          <Menu
            model={menuItems}
            popup
            ref={menu}
            className="tiered-menu-custom"
            onHide={onHideMenu}
            onShow={onShowMenu}
          />
          {!isParentNode && (
            <Button
              icon={PrimeIcons.ELLIPSIS_V}
              text
              className="meatball display-none"
              onClick={(e) => {
                e.stopPropagation();

                if (canRemoveActiveClass) {
                  selectedNodeFormActions = node;
                  setSelectedNode(node);
                  setMenuItems(
                    node.type === labelPrivates ? itemsPrivate : items
                  );
                }
                menu.current!.toggle(e);
              }}
            />
          )}
        </div>
      </div>
    );
  };
  const checkSourceChange = (e: any, nodes: any) => {
    const reorderedNodes = nodes.map((node: any) => ({
      ...node,
      children: node.children.sort(
        (a: any, b: any) => Number(b.isChecked) - Number(a.isChecked)
      ),
    }));

    setNodes(reorderedNodes);
    setSelectedKeys(e.value);
  };

  const selectNode = (e: any) => {
    e.originalEvent.stopPropagation();

    let tempList: any[];
    if (e.node.children) {
      switch (e.node.key) {
        case "CODEX":
          tempList = JSON.parse(JSON.stringify(listSourceProject.codesList));
          saveCheckedStatus({ codesIdsList: tempList, type: "CODEX" });
          break;
        case "ARCHIVE":
          tempList = JSON.parse(JSON.stringify(listSourceProject.sourcesList));
          saveCheckedStatus({ sourcesIdsList: tempList, type: "ARCHIVE" });
          break;
        case "PRIVATE":
          tempList = JSON.parse(
            JSON.stringify(listSourceProject.privateSourcesList)
          );
          saveCheckedStatus({ privateIdsList: tempList, type: "PRIVATE" });
          break;
        default:
          return;
      }
    } else {
      switch (e.node.type) {
        case "CODEX":
          tempList = JSON.parse(JSON.stringify(listSourceProject.codesList));
          let itemCode = tempList.find((item: any) => item.id === e.node.key);
          if (itemCode) {
            itemCode.isChecked = true;
          }

          saveCheckedStatus({
            codesIdsList: tempList.filter((item: any) => item.isChecked),
            type: "CODEX",
          });
          break;
        case "PRIVATE":
          tempList = JSON.parse(
            JSON.stringify(listSourceProject.privateSourcesList)
          );
          let item = tempList.find((item: any) => item.id === e.node.key);
          getStateSource(item.id)
            .then((res) => {
              if (res.data.elaborated) {
                if (item) {
                  item.isChecked = true;
                }
              } else {
                showSnackbar({
                  severity: snackbarSeverityInfo,
                  summary: snackbarSeverityInfo,
                  detail: snackbarSourceNotReady,
                  life: 5000,
                });
              }
              saveCheckedStatus({
                privateIdsList: tempList.filter((item: any) => item.isChecked),
                type: "PRIVATE",
              });
            })
            .catch((_) => { });

          break;
        case "ARCHIVE":
          tempList = JSON.parse(JSON.stringify(listSourceProject.sourcesList));
          let archiveItem = tempList.find(
            (item: any) => item.id === e.node.key
          );
          if (archiveItem) {
            archiveItem.isChecked = true;
          }
          saveCheckedStatus({
            sourcesIdsList: tempList.filter((item: any) => item.isChecked),
            type: "ARCHIVE",
          });
          break;

        default:
          return;
      }
    }
  };

  const unSelectNode = (e: any) => {
    e.originalEvent.stopPropagation();
    let tempList;
    if (e.node.children) {
      switch (e.node.key) {
        case "CODEX":
          saveCheckedStatus({ codesIdsList: [], type: "CODEX" });
          break;
        case "ARCHIVE":
          saveCheckedStatus({ sourcesIdsList: [], type: "ARCHIVE" });
          break;
        case "PRIVATE":
          saveCheckedStatus({ privateIdsList: [], type: "PRIVATE" });
          break;
        default:
          return;
      }
    } else {
      switch (e.node.type) {
        case "CODEX":
          tempList = JSON.parse(
            JSON.stringify(
              listSourceProject.codesList.filter(
                (item: any) => item.id !== e.node.key
              )
            )
          );
          let codeItem = tempList.find((item: any) => item.id === e.node.key);
          if (codeItem) {
            codeItem.isChecked = false;
          }
          saveCheckedStatus({
            codesIdsList: tempList.filter((item: any) => item.isChecked),
            type: "CODEX",
          });
          break;
        case "PRIVATE":
          tempList = JSON.parse(
            JSON.stringify(
              listSourceProject.privateSourcesList.filter(
                (item: any) => item.id !== e.node.key
              )
            )
          );
          let privateItem = tempList.find(
            (item: any) => item.id === e.node.key
          );
          if (privateItem) {
            privateItem.isChecked = false;
          }
          saveCheckedStatus({
            privateIdsList: tempList.filter((item: any) => item.isChecked),
            type: "PRIVATE",
          });
          break;
        case "ARCHIVE":
          tempList = JSON.parse(JSON.stringify(listSourceProject.sourcesList));
          let archiveItem = tempList.find(
            (item: any) => item.id === e.node.key
          );
          if (archiveItem) {
            archiveItem.isChecked = false;
          }

          saveCheckedStatus({
            sourcesIdsList: tempList.filter((item: any) => item.isChecked),
            type: "ARCHIVE",
          });

          break;
        default:
          return;
      }
    }
  };

  const saveCheckedStatus = ({
    type,
    codesIdsList,
    sourcesIdsList,
    privateIdsList,
  }: {
    type: "PRIVATE" | "CODEX" | "ARCHIVE";
    codesIdsList?: ProjectSource[];
    sourcesIdsList?: ProjectSource[];
    privateIdsList?: ProjectSource[];
  }) => {
    const payload: CheckSourceRequest = {
      projectId: projectId,
      type: type,
      sourcesIdsList: (sourcesIdsList
        ? sourcesIdsList
        : listSourceProject.sourcesList
      )?.map((item: any) => item.id),
      codesIdsList: (codesIdsList
        ? codesIdsList
        : listSourceProject.codesList
      )?.map((item: any) => item.id),
      privateIdsList: (privateIdsList
        ? privateIdsList
        : listSourceProject.privateSourcesList
      )?.map((item: any) => item.id),
    };
    checkSource(payload)
      .then((_) => {
        checkLastResetChat(projectId).then((res) => {
          if (res.data.canShowWarning) {
            dispatch(setCheckInactiveAnswers(true));
            showSnackbar({
              severity: "warn",
              summary: snackbarResetChat,
              detail: snackbarSummaryResetChatSubTitle,
              life: 5000,
            });
          }
        }).catch((_) => { });
        dispatch(resetLoadedStatus());
      })
      .catch((_) => { });
  };
  return (
    <>
      <Divider className="absolute absolute-left-0" />
      <Tree
        value={nodes}
        className="tree-content absolute absolute-left-0 tree-source-project"
        selectionMode="checkbox"
        selectionKeys={selectedKeys}
        onSelectionChange={(e) => checkSourceChange(e, nodes)}
        onSelect={selectNode}
        onUnselect={unSelectNode}
        metaKeySelection={false}
        nodeTemplate={nodeTemplate}
      />
      {showModalPrivateSource && (
        <ModalPrivateSource
          projectId={projectId}
          source={detailSource}
          modalVisibile={showModalPrivateSource}
          onClose={() => setShowModalPrivateSource(false)}
        />
      )}
      {showModalDetailSource && (
        <ModalDetailSourceProject
          items={selectedNode.type === labelPrivates ? itemsPrivate : items}
          source={detailSource}
          showDialog={showModalDetailSource}
          onClose={() => setShowModalDetailSource(false)}
        />
      )}
    </>
  );
};
